import script from "./Trash.vue?vue&type=script&setup=true&lang=js"
export * from "./Trash.vue?vue&type=script&setup=true&lang=js"

import "./Trash.vue?vue&type=style&index=0&id=46aae8fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46aae8fc"]])

export default __exports__